export default theme => ({
  comment: {
    color: '#424953',
    padding: 10,
    border: '1px solid #E0E0E0',
    margin: '10px 0 10px 0',
    boxShadow: '1px 1px 3px #F5F5F5',
    background: '#fcfcfc',
    borderRadius: 2,
    marginBottom: '1em',
    fontSize: 12,

    '& blockquote': {
      lineHeight: 1.6,
      color: '#8a8a8a',
      margin: '0 0 1rem',
      padding: '.5625rem 1.25rem 0 1.1875rem',
      borderRight: '1px solid #cacaca',
    }
  },
  commentAuthor: {
    fontSize: '0.90rem',
    fontWeight: 'bold',
    color: '#fc4a38',
    margin: '0 10px 5px 0',
  },
  tools: {
    textAlign: 'left'
  }
})

